import React, { Component } from "react";
import Spinner from "../../lib/spinner";
import UserForm from "../sign_up/user_form";
import "./account_page.scss";
import { If } from "react-extras";
import isEmpty from "lodash/isEmpty";

class ProfileSettings extends Component {
  constructor(props) {
    super(props);
    this.logOut = this.logOut.bind(this);
  }

  componentDidMount() {
    this.props.updateUserClear(); // clears success message.
    if (isEmpty(this.props.user)) {
      this.props.fetchUser(this.props.user.uuid, this.props.user.authToken);
    }
  }

  render() {
    return (
      <div>
        <Spinner isLoading={this.props.isLoading || this.props.isLoadingForm} />
        <If condition={!this.props.isLoading}>
          <div>
            <h1>Account Info</h1>
            <UserForm
              onSubmit={formData => {
                var newData = Object.assign({}, formData);

                this.props.updateUser(newData, this.props.user);
              }}
              user={this.props.user}
              initialValues={this.props.user}
              isLoading={this.props.isLoadingForm || this.props.isLoadingVerification}
              hasError={this.props.hasError}
              errorMessage={this.props.errorMessage}
              validationErrors={this.props.validationErrors}
              sendVerificationEmail={this.props.sendVerificationEmail}
              password={this.props.password}
              logOut={this.logOut}
              mode="edit"
            />
          </div>
        </If>
      </div>
    );
  }

  logOut() {
    if (this.props && this.props.user) {
      this.props.logOut(this.props.user.authToken);
    }
  }
}

export default ProfileSettings;
